import { SxProps, Theme, styled } from '@mui/material/styles';
import React, { ForwardedRef, forwardRef } from 'react';
import { Link as RawLink, LinkProps } from 'react-router-dom';
import Typography from '@mui/material/Typography';
const Link = styled(RawLink)<LinkProps>(({ theme, color }) => ({
  marginRight: '0.1em',
  display: 'flex',
  alignItems: 'center',
  color: color === 'primary' ? theme.palette.red[60] : theme.palette.blue[60],
}));

const StyledIcon = styled('span')(
  () => `
  margin-right: 0.70em;
  position: relative;
  top: 0.15em;
  `,
);

export type HrefLinkProps = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  text?: string;
  classname?: string;
  href: string;
  id?: string;
  title?: string;
  sx?: SxProps<Theme>;
  color?: 'primary' | 'secondary';
  target?: '_blank' | '_self' | '_parent' | '_top' | string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const HrefLink = forwardRef(
  (
    { text, href, icon, id, title, children, sx, target = '_blank', color = 'primary', onClick }: HrefLinkProps,
    ref: ForwardedRef<HTMLAnchorElement>,
  ): React.ReactElement => {
    return (
      <Link
        onClick={onClick}
        id={id}
        to={href}
        title={title || ''}
        target={target}
        rel="noreferrer"
        sx={sx}
        ref={ref}
        color={color}
      >
        <Typography variant="body1Light" color={color}>
          {icon && <StyledIcon>{icon}</StyledIcon>}
          {text || children}
        </Typography>
      </Link>
    );
  },
);
